import ReactPaginate from "react-paginate";
import { HiDotsHorizontal } from "react-icons/hi";
import Icons from "../../assets/icon";

const Pagination = ({
  setCurrentPage,
  currentPage,
  total_pages,
  has_more_pages,
}) => {
  const handlePageClick = (event) => {
    setCurrentPage(event.selected + 1); // react-paginate is 0-based, yours is 1-based
  };

  return (
    <ReactPaginate
      breakLabel={
        <div className="px-1.5 py-2 text-secondary bg-[#787878] rounded-md flex items-center">
          <HiDotsHorizontal className="text-lg" />
        </div>
      }
      nextLabel={
        <button
          className="px-2 py-1 text-secondary bg-[#787878] rounded-md flex items-center gap-2 disabled:opacity-50"
          disabled={!has_more_pages}
        >
          <span>Next</span>
          <img
            src={Icons.paginationIcon}
            className="rotate-180 w-2 h-2.5"
            alt="pagination Icon"
          />
        </button>
      }
      previousLabel={
        <button
          className="px-2 py-1 text-secondary bg-[#787878] rounded-md flex items-center gap-2 disabled:opacity-50"
          disabled={currentPage === 1}
        >
          <img
            src={Icons.paginationIcon}
            className="w-2 h-2.5"
            alt="pagination Icon"
          />
          <span>Prev</span>
        </button>
      }
      onPageChange={handlePageClick}
      forcePage={currentPage - 1}
      pageCount={total_pages}
      marginPagesDisplayed={1}
      pageRangeDisplayed={5}
      containerClassName="flex items-center gap-2"
      pageLinkClassName="px-2 py-1 border border-[#787878] rounded-md text-secondary block"
      activeLinkClassName="border-goldMetallic border bg-[#787878] text-secondary block"
      disabledClassName="opacity-50 cursor-not-allowed"
    />
  );
};

export default Pagination;
